import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import MatchPlay from "../views/MatchPlay.vue";
import Matches from "../views/Matches.vue";
import MatchDetails from "../views/MatchDetails.vue";
import About from "../views/About.vue";
import MatchNew from "../views/MatchNew.vue";
import SpondLogin from "../views/SpondLogin.vue";
import SpondMatches from "../views/SpondMatches.vue";
import SpondGroups from "../views/SpondGroups.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Matches",
    component: Matches
  },
  {
    path: "/new",
    name: "MatchNew",
    component: MatchNew
  },
  {
    path: "/spond/matches",
    name: "SpondMatches",
    component: SpondMatches
  },
  {
    path: "/spond/groups",
    name: "SpondGroups",
    component: SpondGroups
  },
  {
    path: "/spond/login",
    name: "SpondLogin",
    component: SpondLogin
  },
  
  {
    path: "/play/:id",
    name: "PlayMatch",
    component: MatchPlay
  },
  {
    path: "/edit/:id",
    name: "MatchDetails",
    component: MatchDetails
  },
  {
    path: "/about",
    name: "About",
    component: About
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
